export * from './src/module';



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/~/ng-trim-value-accessor/index.ts